import { apiGet, apiPost } from './api';

export interface MyReferralResponse {
  code: string;
  referredByCode?: string | null;
}

/** GET /referrals/my — pega/cria o código de referência da conta logada */
export const getMyReferral = () => apiGet<MyReferralResponse>('/referrals/my');

/** POST /referrals/redeem — registra que este user foi referido pelo `code` */
export const redeemReferral = (code: string) =>
  apiPost<{ status: string; referredByCode?: string }>('/referrals/redeem', { Code: code });

export interface AdminReferralRow {
  userNum: number;
  accountId?: string | null;
  code: string;
  referredCount: number;
  referredByCode?: string | null;
  createdAt?: string | null;
}

/** GET /admin/referrals — lista contas + contagem de referidos (GM1+) */
export const listAdminReferrals = () =>
  apiGet<AdminReferralRow[]>('/admin/referrals');

/** Helper: chave do localStorage onde guardamos o código quando o user clica
 * /cadastro?ref=X — limpamos após o cadastro completar com sucesso. */
export const REFERRAL_STORAGE_KEY = 'liberty_referral_code';
